import {GetPageResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/custom_pages/v1/service.types';
import {ErrorBoundary} from '@aboutyou/ui-components';
import React from 'react';
import {AssetSliderModule} from '../../../features/ContentBlocks/AssetSliderModule/AssetSliderModule';
import {CTA} from '../../../features/ContentBlocks/CTA/CTA';
import {DoubleTile} from '../../../features/ContentBlocks/DoubleTile/DoubleTile';
import {Header} from '../../../features/ContentBlocks/Header/Header';
import {Headline} from '../../../features/ContentBlocks/Headline/Headline';
import {ImageTextModule} from '../../../features/ContentBlocks/ImageTextModule/ImageTextModule';
import {ImageTile} from '../../../features/ContentBlocks/ImageTile/ImageTile';
import {NewsletterPushSignup} from '../../../features/ContentBlocks/NewsletterPushSignup/NewsletterPushSignup';
import {Text} from '../../../features/ContentBlocks/Text/Text';
import {ThreeColumnsModule} from '../../../features/ContentBlocks/ThreeColumnsModule/ThreeColumnsModule';
import {VideoTile} from '../../../features/ContentBlocks/VideoTile/VideoTile';
import {useCmsWebSDK} from './useCmsWebSDK';

export interface ContentBlocksViewProps {
  assetSliderConstrained?: boolean;
  hideAssetSliderSideButtons?: boolean;
}

export const ContentBlocksView: React.FC<
  GetPageResponse & ContentBlocksViewProps
> = ({contentBlocks, assetSliderConstrained, hideAssetSliderSideButtons}) => {
  useCmsWebSDK();

  return (
    <>
      {contentBlocks.map((block, index) => {
        switch (block.contentBlock?.$case) {
          case 'header':
            return (
              <ErrorBoundary
                key={index}
                ErrorComponent={null}
                renderContext="contentBlocks_header"
              >
                <Header
                  content={block.contentBlock.header}
                  blockId={block.id}
                />
              </ErrorBoundary>
            );
          case 'headline':
            return (
              <ErrorBoundary
                key={index}
                ErrorComponent={null}
                renderContext="contentBlocks_headline"
              >
                <Headline
                  content={block.contentBlock.headline}
                  blockId={block.id}
                />
              </ErrorBoundary>
            );
          case 'text':
            return (
              <ErrorBoundary
                key={index}
                ErrorComponent={null}
                renderContext="contentBlocks_text"
              >
                <Text content={block.contentBlock.text} blockId={block.id} />
              </ErrorBoundary>
            );
          case 'imageTextModule':
            return (
              <ErrorBoundary
                key={index}
                ErrorComponent={null}
                renderContext="contentBlocks_imageTextModule"
              >
                <ImageTextModule
                  content={block.contentBlock.imageTextModule}
                  blockId={block.id}
                />
              </ErrorBoundary>
            );
          case 'threeColumnsModule':
            return (
              <ErrorBoundary
                key={index}
                ErrorComponent={null}
                renderContext="contentBlocks_threeColumnsModule"
              >
                <ThreeColumnsModule
                  content={block.contentBlock.threeColumnsModule}
                  blockId={block.id}
                />
              </ErrorBoundary>
            );
          case 'imageTile':
            return (
              <ErrorBoundary
                key={index}
                ErrorComponent={null}
                renderContext="contentBlocks_imageTile"
              >
                <ImageTile
                  content={block.contentBlock.imageTile}
                  blockId={block.id}
                />
              </ErrorBoundary>
            );
          case 'videoTile':
            return (
              <ErrorBoundary
                key={index}
                ErrorComponent={null}
                renderContext="contentBlocks_videoTile"
              >
                <VideoTile
                  content={block.contentBlock.videoTile}
                  blockId={block.id}
                />
              </ErrorBoundary>
            );
          case 'cta':
            return (
              <ErrorBoundary
                key={index}
                ErrorComponent={null}
                renderContext="contentBlocks_cta"
              >
                <CTA content={block.contentBlock.cta} blockId={block.id} />
              </ErrorBoundary>
            );
          case 'doubleTile':
            return (
              <ErrorBoundary
                key={index}
                ErrorComponent={null}
                renderContext="contentBlocks_doubleTile"
              >
                <DoubleTile
                  content={block.contentBlock.doubleTile}
                  blockId={block.id}
                />
              </ErrorBoundary>
            );
          case 'assetSlider':
            return (
              <ErrorBoundary
                key={index}
                ErrorComponent={null}
                renderContext="contentBlocks_assetSlider"
              >
                <AssetSliderModule
                  content={block.contentBlock.assetSlider}
                  constrained={assetSliderConstrained}
                  hideSideButtons={hideAssetSliderSideButtons}
                  blockId={block.id}
                />
              </ErrorBoundary>
            );
          case 'newsletterPushSignup':
            return (
              <ErrorBoundary
                key={index}
                ErrorComponent={null}
                renderContext="contentBlocks_newsletterPushSignup"
              >
                <NewsletterPushSignup
                  content={block.contentBlock.newsletterPushSignup}
                />
              </ErrorBoundary>
            );

          default:
            return null;
        }
      })}
    </>
  );
};
